import { useScreenSize } from '@/hooks';
import { useId } from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const RestroomForDisabledIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    const maskId = useId();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="30" y="19" width="105" height="121">
                <path d="M135 19.9976H30V139.998H135V19.9976Z" fill="white" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    d="M79.4775 50.935C85.6905 50.935 90.7275 45.8983 90.7275 39.6851C90.7275 33.4719 85.6905 28.4351 79.4775 28.4351C73.2645 28.4351 68.2275 33.4719 68.2275 39.6851C68.2275 45.8983 73.2645 50.935 79.4775 50.935Z"
                    stroke={color}
                    strokeWidth="6"
                    strokeLinejoin="round"
                />
                <path
                    d="M79.4775 54.446V94.6475H102.872L116.008 123.872H128.159"
                    stroke={color}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M98.213 119.669C92.0805 129.587 81.103 136.212 68.573 136.212C49.3425 136.212 33.7842 120.654 33.7842 101.423C33.7842 82.193 49.3425 66.6345 68.573 66.6345"
                    stroke={color}
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M79.4775 73.108H103.818" stroke={color} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
};
